import { makeStyles } from "@material-ui/core";
import MotorcycleIcon from "@material-ui/icons/Motorcycle";
import PhoneAndroidIcon from "@material-ui/icons/PhoneAndroid";
import Form from "@saleor/components/Form";
import SingleAutocompleteSelectField from "@saleor/components/SingleAutocompleteSelectField";
import useStateFromProps from "@saleor/hooks/useStateFromProps";
import { maybe } from "@saleor/misc";
import { OrderDetails_order } from "@saleor/motherOrders/types/OrderDetails";
import { SmopOrderStatusEnum } from "@saleor/types/globalTypes";
import createSingleAutocompleteSelectHandler from "@saleor/utils/handlers/singleAutocompleteSelectChangeHandler";
import * as React from "react";

import { RiderDetails_order } from "../../../types/RiderDetails";
import { searchRider_search_edges_node } from "../../../types/searchRider";
import { InHouseInitialFormData } from "../types";

interface InHouseRiderProps {
  riders?: searchRider_search_edges_node[];
  rider: RiderDetails_order | OrderDetails_order;
  fetchMoreRider: any;
  fetchRider: any;
  initialForm: InHouseInitialFormData;
  setSelectedRider: (data: string) => void;
  status: SmopOrderStatusEnum;
}

const useStyles = makeStyles(
  () => ({
    content: {
      marginBottom: "17px"
    },
    riderDetails: {
      alignItems: "left",
      display: "flex",
      flexDirection: "column",
      justifyContent: "left"
    },
    riderDetailsContent: {
      alignItems: "center",
      display: "flex",
      flexWrap: "wrap",
      fontSize: "17px",
      marginBottom: "6px"
    },
    sectionLabel: {
      margin: "0px",
      marginBottom: "6px",
      marginLeft: "5px"
    }
  }),
  { name: "InHouseRider" }
);

const InHouseRider: React.FC<InHouseRiderProps> = props => {
  const {
    riders,
    rider,
    fetchMoreRider,
    fetchRider,
    initialForm,
    setSelectedRider,
    status
  } = props;
  const classes = useStyles(props);
  const [riderTempList, setRiderTempList] = React.useState([]);
  const [riderDisplayName, setRiderDisplayName] = useStateFromProps(
    maybe(() => rider?.rider)
      ? `${rider?.rider?.firstName} ${rider?.rider?.lastName} `
      : ""
  );

  const getRiderDetails = riderId =>
    maybe(() => riderTempList.find(e => e.id === riderId));

  React.useEffect(() => {
    setRiderTempList(riders);
  }, [riders]);

  const riderChoices = maybe(
    () =>
      riders.map(rider => ({
        label: `${rider.firstName} ${rider.lastName}`,
        value: rider?.id
      })),
    []
  );

  return (
    <div style={{ marginBottom: "12px" }}>
      <Form initial={initialForm} confirmLeave>
        {({ data: formData, change }) => {
          const handleSelectBrand = createSingleAutocompleteSelectHandler(
            change,
            setRiderDisplayName,
            riderChoices
          );
          setSelectedRider(formData.riderId);

          return (
            <>
              <h3
                id="txtAssignRiderDialogAvailableRider"
                className={classes.sectionLabel}
              >
                Available Rider
              </h3>
              <div
                id="cmpAdminFulfillmentAssignRiderDialogInHouseDropdown"
                className={classes.content}
              >
                <SingleAutocompleteSelectField
                  label={"select rider"}
                  displayValue={riderDisplayName}
                  disableOnBlur={true}
                  onChange={event => {
                    handleSelectBrand(event);
                    change({
                      target: {
                        name: "riderName",
                        value: getRiderDetails(event.target.value).firstName
                      }
                    });
                    change({
                      target: {
                        name: "riderLastName",
                        value: getRiderDetails(event.target.value).lastName
                      }
                    });
                    change({
                      target: {
                        name: "riderContactNo",
                        value: getRiderDetails(event.target.value).contactNo
                      }
                    });
                  }}
                  choices={riderChoices}
                  name="riderId"
                  value={formData.riderId}
                  fetchChoices={fetchRider}
                  {...fetchMoreRider}
                  disabled={
                    status === SmopOrderStatusEnum.CANCELED ||
                    status === SmopOrderStatusEnum.COMPLETED
                  }
                />
              </div>
              <h3
                id="txtAdminFulfillmentAssignRiderDialogInHouseRiderDetails"
                className={classes.sectionLabel}
              >
                Rider Details
              </h3>
              <div
                id="cmpAdminFulfillmentAssignRiderDialogInHouseRiderDetails"
                className={classes.riderDetails}
              >
                <span
                  id="txtAdminFulfillmentAssignRiderDialogInHouseRiderName"
                  className={classes.riderDetailsContent}
                >
                  <MotorcycleIcon
                    id="icnAdminFulfillmentAssignRiderDialogInHouseMotorcycle"
                    style={{
                      color: "#9B51E0",
                      fontSize: "33px",
                      marginRight: "10px"
                    }}
                  />
                  {formData.riderName
                    ? `${formData.riderName} ${formData.riderLastName}`
                    : "--"}
                </span>
                <span
                  id="txtAdminFulfillmentAssignRiderDialogInHouseRiderPhone"
                  className={classes.riderDetailsContent}
                >
                  <PhoneAndroidIcon
                    style={{
                      color: "#9B51E0",
                      fontSize: "27px",
                      marginLeft: "4px",
                      marginRight: "13px"
                    }}
                  />
                  {formData.riderContactNo ? formData.riderContactNo : "--"}
                </span>
              </div>
            </>
          );
        }}
      </Form>
    </div>
  );
};

export default InHouseRider;
